/*
 * @Description:
 * @Autor: xiawenlong
 * @Date: 2021-03-10 10:23:49
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-04-12 14:40:28
 */
import Layout from '@/layout'

export default [
  {
    path: '/video',
    component: Layout,
    children: [
      {
        path: '/video',
        name: 'Video',
        component: () => import(/*webpackChunkName:'Video'*/ '@/views/video'),
        meta: { title: '精选', homePage: true },
      },
    ],
  },
  {
    path: '/videoInfo/:organizationId',
    name: 'VideoInfo',
    component: () => import(/*webpackChunkName:'VideoInfo'*/ '@/views/video/VideoInfo'),
    meta: { title: '学堂详情' },
  },
  {
    path: '/videoResult',
    name: 'VideoResult',
    component: () => import(/*webpackChunkName:'VideoResult'*/ '@/views/video/VideoResult'),
    meta: { title: '学堂详情' },
  },
  {
    path: '/videoShare',
    name: 'VideoShare',
    component: () => import(/*webpackChunkName:'VideoShare'*/ '@/views/video/VideoShare'),
    meta: { title: '分享' },
  },
]
